import PrivateLayout from "@/components/layouts/private-layout";
import AdminsPage from "@/pages/admins";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admins/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <AdminsPage />
    </PrivateLayout>
  );
}
